module.exports = __webpack_public_path__ + "img/Solanum_tuberosum.b6774a3a.jpg";